import React from "react";
import { get } from "lodash-es";
import AppSetting from "../../config/AppSetting";
import { message } from "antd";
import ProcedureDetailService from "../../service/procedureFile/ProcedureDetailService";
import { getDate } from "../../app/publicDictionaryValues";
import appService from "../../service/app";

export default class BaseComponent extends React.Component<any, any> {
  get appSetting() {
    return AppSetting;
  }

  componentDidMount() {
    const pmpMessage = sessionStorage.getItem("pmp_reload_message");
    if (pmpMessage) {
      try {
        const { type, message, duration } = JSON.parse(pmpMessage);
        switch (type) {
          case "success":
            this._alertSuccess(message, duration);
            break;
          case "error":
            this._alertError(message, duration);
            break;
          case "warning":
            this._alertWarning(message, duration);
            break;
          default:
            break;
        }
        sessionStorage.removeItem("pmp_reload_message");
      } catch (e) {
        console.error("Failed to parse reload message:", e);
      }
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state === null || !this.state.isError) {
      return;
    }

    if (this.state.isError) {
      throw Error(this.state.error.message);
    }
  }

  setError(haveError: any, error: any) {
    if (this) this.setState({ isError: haveError, error: error });
  }

  _showLoading = () => {
    if (this.props.history == null) {
      return;
    }
    if (this.props.history.location.state === undefined) {
      this.props.history.replace({
        ...this.props.history,
        state: { showLoad: 1 },
        search: this.props.history.location.search,
      });
      return;
    }

    this.props.history.replace({
      ...this.props.history,
      state: { showLoad: this.props.history.location.state.showLoad + 1 },
      search: this.props.history.location.search,
    });
  };

  _hideLoading = () => {
    if (this.props.history == null) {
      return;
    }

    if (this.props.history.location.state === undefined) {
      return;
    }

    this.props.history.replace({
      ...this.props.history,
      state: { showLoad: this.props.history.location.state.showLoad - 1 },
      search: this.props.history.location.search,
    });
  };

  _alertSuccess = (msg: any, duration = 3) => {
    message.success(msg, duration);
  };

  _alertError = (msg: any, duration = 3) => {
    message.error(msg, duration);
  };

  _alertWarning = (msg: any, duration = 3) => {
    message.warning(msg, duration);
  };

  _getDate = () => {
    return getDate();
  };

  _formateDate = (date: any) => {
    if (date === null) {
      return date;
    }
    const dateTime = new Date(date);
    let year = dateTime.getFullYear();
    let month: any = dateTime.getMonth() + 1;
    let day: any = dateTime.getDate();

    if (month < 10) {
      month = "0" + month;
    }

    if (day < 10) {
      day = "0" + day;
    }

    return month + "/" + day + "/" + year;
  };

  _generateGUID() {
    let crypto = window.crypto || (window as any).msCrypto;
    if (!crypto) {
      console.log("Crypto API not supported");
      return;
    }
    let buf = new Uint16Array(8);
    crypto.getRandomValues(buf);
    return (
      buf[0].toString(16) +
      buf[1].toString(16) +
      "-" +
      buf[2].toString(16) +
      "-" +
      buf[3].toString(16) +
      "-" +
      buf[4].toString(16) +
      "-" +
      buf[5].toString(16) +
      buf[6].toString(16) +
      buf[7].toString(16)
    );
  }

  _getRoutingParam(paramName: any) {
    if (this.props.match === undefined) {
      return this.props.params ? this.props.params[paramName] : null;
    } else if (this.props.match === null || this.props.match.params == null) {
      return;
    }
    return this.props.match.params[paramName];
  }

  _setLock(id: any, actionType: any, isLock: any) {
    const para = {
      procedureId: id,
      procedureSectionType: actionType,
      setLock: isLock,
      timeOutMins: 20,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        //this.is an empty function
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  }

  getCurrentDate() {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  }

  decodeHTMLEntities(text: any) {
    const element = document.createElement("div");
    if (text) {
      element.innerHTML = text;
      text = element.textContent;
      element.textContent = "";
    }
    return text;
  }

  richTextEditorValueNotEmpty(editor: any) {
    const wordCountBody = get(editor, "plugins.wordcount.body");
    return typeof wordCountBody?.getWordCount === "function" && wordCountBody.getWordCount() > 0;
  }

  validateToken() {
    appService.validateToken(
      () => console.log("Validate Token Success"),
      () => this._alertError("Validate Token Failed")
    );
  }
}
